import Sidebar from './sidebar';

const SidebarPlugin = {
  install(Vue) {
    Vue.component(Sidebar.name, 'Sidebar');
  }
};

export default SidebarPlugin;
